import React from 'react';

export function Empty() {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}
